import OtaActiveDevicesListContainer from './OtaActiveDevicesListContainer';

export default OtaActiveDevicesListContainer;
